import { create } from 'zustand';

// Cross-widget channel for "which marker is hovered". A list (the planner
// picker, a results table) sets the hovered id on row hover; the map opens
// that marker's popup. A map in `sync` mode sets it the other way round
// (`source: 'map'`) so the list can highlight the row. Ephemeral, single
// value — only one map is visible at a time, so a process-global store is
// enough.
export type HoveredMarkerSource = 'list' | 'map';

type HoveredMarkerState = {
  hoveredId: string | null;
  /** Where the hover happened: a list row, or the marker on the map. */
  hoveredSource: HoveredMarkerSource;
  setHovered: (id: string | null, source?: HoveredMarkerSource) => void;
};

export const useHoveredMarkerStore = create<HoveredMarkerState>()((set) => ({
  hoveredId: null,
  hoveredSource: 'list',
  setHovered: (hoveredId, hoveredSource = 'list') =>
    set({ hoveredId, hoveredSource }),
}));
